import LocalStore from './LocalStore';
// initial state
var state = {
    storageGD: new LocalStore({}).gd,
    storageUser: new LocalStore({}).user,
    storageCustom: {},
    customId: ''
};
// getters
var getters = {
    storageGD: function (state) { return state.storageGD; },
    storageUser: function (state) { return state.storageUser; },
    storageCustom: function (state) { return state.storageCustom; },
    webPath: function (state) {
        return state.storageGD.webCtxPath;
    }
};
// actions
var actions = {
    storageInit: function (_a, _b) {
        var commit = _a.commit;
        var customId = _b.customId;
        var localStorage = new LocalStore({ customId: customId });
        commit('storageCustom', { id: customId, data: localStorage.custom });
        commit('storageSetCustomId', customId);
    }
};
// mutations
var mutations = {
    storageSetCustomId: function (state, id) {
        state.customId = id;
    },
    storageGD: function (state, gdInt) {
        state.storageGD = Object.assign({}, state.storageGD, gdInt);
        localStorage.setItem('gd', JSON.stringify(state.storageGD));
    },
    storageUser: function (state, userInt) {
        state.storageUser = Object.assign({}, state.storageUser, userInt);
        localStorage.setItem('user', JSON.stringify(state.storageUser));
    },
    /**
     * id is optional - it's using the id from the storageInit: customId as default
     */
    storageCustom: function (state, _a) {
        var id = _a.id, data = _a.data;
        // TODO: apply deep merge of objects
        state.storageCustom = Object.assign({}, state.storageCustom, data);
        localStorage.setItem(id || state.customId, JSON.stringify(state.storageCustom));
    }
};
export default {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
//# sourceMappingURL=vuexLocalStore.js.map